const lang = {
    en: {
        search : "Search",
        gptPlaceHolder : "What would you like to watch today??"
    },
    hindi: {
        search : "खोज",
        gptPlaceHolder: "आज आप क्या देखना चाहेंगे??"     
    },
    spanish: {
        search: "Buscar",
        gptPlaceHolder: "¿Qué te gustaría ver hoy?"
    }

}

export default lang;